import { MultiplexedChannel } from 'infrastructure/t4/ChannelResolver/MultiplexedChannel';
import { LatencyMeasure } from './LatencyMeasure';

export class MultiChannelLatencyMeasure {
    private latencyMeasuresPerChannel = new Array<LatencyMeasure>();
    private _tag: string;
    private _channel: MultiplexedChannel;

    constructor(tag: string, channel: MultiplexedChannel) {
        this._tag = tag;
        this._channel = channel;
        if (channel.channels) {
            this.latencyMeasuresPerChannel = this._channel.channels.map(ch => new LatencyMeasure(tag, ch));
        } else {
            this.latencyMeasuresPerChannel[0] = new LatencyMeasure(tag, channel);
        }
    }

    get tag() {
        return this._tag;
    }

    update() {
        this.latencyMeasuresPerChannel.map(l => l.update());
    }

    reset() {
        this.latencyMeasuresPerChannel.map(l => l.reset());
    }

    get lastMeasurements() { return this.latencyMeasuresPerChannel.map(l => l.lastMeasurements); }
    get averageMeasurements() { return this.latencyMeasuresPerChannel.map(l => l.averageMeasurements); }
}
